export default "__VITE_ASSET__DcBjnPN___"